export default __webpack_public_path__ + "static/media/rate.72612c3c.svg";